export default "__VITE_ASSET__Bi64Bhhn__"